import V from 'voca';
import ExpandableTextComponent from '72cms-ui/components/form-elements/ExpandableTextComponent';
import UrlSelectComponent from '72cms-ui/components/form-elements/UrlSelectComponent';
import RadioListComponent from '72cms-ui/components/form-elements/RadioListComponent';
import ScopeSelectComponent from '72cms-ui/components/form-elements/ScopeSelectComponent';
import PageDetailsFormLayout from '72cms-ui/components/form-elements/PageDetailsFormLayout';
import PageDetailsWithScopesFormLayout from '72cms-ui/components/form-elements/PageDetailsWithScopesFormLayout';
import PageBuilderComponent from '72cms-ui/components/helpers/PageBuilderComponent';
import DropdownActionsButtonComponent from '72cms-ui/components/helpers/DropdownActionsButtonComponent';

export default {
    sections: ['details', 'content', 'image', 'meta data'],
    groups: {
        content_details: {
            component: PageBuilderComponent,
            showOnSection: 'content',
        },
        page_settings: {
            component: PageDetailsWithScopesFormLayout,
            showOnSection: 'details',
        },
    },
    toolbar: [
        'add', 'edit', 'separator', 'active', 'preview', 'delete',
    ],
    fields: {
        parent_id: {
            label: 'Parent Page',
            section: 'details',
            position: 0,
            cssClass: 'custom lable-lh',
        },

        name: {
            section: 'details',
            position: 1,
            description: '',
            cssClass:' lable-lh',
        },

        homepage: {
            section: 'details',
            group: 'page_settings',
            position: 2,
        },
        show_in_menu: {
            section: 'details',
            group: 'page_settings',
            position: 4,
        },
        show_in_footer: {
            section: 'details',
            group: 'page_settings',
            position: 5,
        },
        show_in_responsive_menu: {
            section: 'details',
            group: 'page_settings',
            position: 6,
        },

        content_type: {
            label: 'Page type',
            section: 'details',
            group: 'page_settings',
            position: 7,
            component: RadioListComponent,
            description: 'Is this a regular page you want to add content to or a link that redirect to another page/site?',
            values: [
                { id: 'default', description: 'This is a physical page' },
                { id: 'redirect', description: 'This page redirects to another page' },
            ],
        },

        template: {
            label: 'Choose page template',
            section: 'details',
            group: 'page_settings',
            position: 8,
            component: RadioListComponent,
            description: 'What type of page is this?',
            values: function (value, schema) {
                return [
                    { id: 'homepage', name: 'Homepage', image: '/icons/Page Template Type/Homepage@3x.svg',
                        description: 'Homepage template.  Use this template once within your site.'},
                    { id: 'default', name: 'Basic (default)', image: '/icons/Page Template Type/Basic Page Full width.svg',
                        description: 'Default page template'},
                    { id: 'about', name: 'About us template', image: '/icons/Page Template Type/Basic Page with Sidebar.svg',
                        description: 'Default page template with submenu'},
                    { id: 'products', name: 'Products', image: '/icons/Page Template Type/Products@2x.png',
                        description: 'Product page template.  Template will serve all content from the products module'},
                    { id: 'news', name: 'News', image: '/icons/Page Template Type/Blog.svg',
                        description: 'News page template. Template will serve all content from the news module'},
                    { id: 'contact', name: 'Contact', image: '/icons/Page Template Type/Contact Page.svg',
                        description: 'Contact page template will display contact details, location map and default contact form'},
                    { id: 'resources', name: 'Resources', image: '/icons/Page Template Type/File Download.svg',
                        description: 'Resources page template. Template will serve all content from the page images and files'},
                    { id: 'services', name: 'Service', image: '/icons/Page Template Type/Distributor Locations.svg',
                        description: 'Service page template. Template will serve all content from the stockist module'},
                     { id: 'staff_members', name: 'Staff', image: '/icons/Page Template Type/Distributor Locations.svg',
                        description: 'Staff page template. Template will serve all content from the stockist module'},
                    { id: 'sitemap', name: 'Site Map', image: '/icons/Page Template Type/Site Map.svg',
                        description: 'HTML sitemap template'},
                ];
            },
            disabled: function (value, schema, data) {
                return data.content_type == 'redirect';
            },
            listener: function (entry, entries, $form) {
                const value = entry.newValue || entry.value;
                if (entry.name == 'content_type') {
                    if (value == 'redirect') {
                        this.disabled = true;
                    } else {
                        this.disabled = false;
                    }
                }
            },
        },

        redirect_url: {
            label: 'Redirect URL',
            // config for lazy loading page url
            group: 'page_settings',
            component: UrlSelectComponent,
            link: '/api/pages/_ref_',
            description: 'Choose a page from this site to redirect to or enter an external URL',

            section: 'details',
            position: 9,
            disabled: function (value, schema, data) {
                return data.content_type != 'redirect';
            },
            listener: function (entry, entries, $form) {
                const value = entry.newValue || entry.value;
                if (entry.name == 'content_type') {
                    if (value == 'redirect') {
                        this.disabled = false;
                    } else {
                        this.disabled = true;
                    }
                }
            },
        },

        open_in_new_tab: {
            section: 'details',
            group: 'page_settings',
            position: 10,
            disabled: function (value, schema, data) {
                return data.content_type != 'redirect';
            },
            listener: function (entry, entries, $form) {
                const value = entry.newValue || entry.value;
                if (entry.name == 'content_type') {
                    if (value == 'redirect') {
                        this.disabled = false;
                    } else {
                        this.disabled = true;
                    }
                }
            },
        },

        heading: {
            section: 'content',
            group: 'content_details',
            position: 0,
            disabled: function (value, schema, data) {
                return data.content_type == 'redirect';
            },
            listener: function (entry, entries, $form) {
                const value = entry.newValue || entry.value;
                if (entry.name == 'content_type') {
                    if (value == 'redirect') {
                        this.disabled = true;
                    } else {
                        this.disabled = false;
                    }
                }
            },
        },

        content: {
            section: 'content',
            group: 'content_details',
            position: 1,
            editorClass: 'copy main-copy',
            editorConfig: {
                style_formats: [
                    {title: 'Intro Size', block: 'p ', classes: 'intro'},
                    {title: 'Script', block: 'p', classes: 'script'},
                ],
            },
            disabled: function (value, schema, data) {
                return data.content_type == 'redirect';
            },
            listener: function (entry, entries, $form) {
                const value = entry.newValue || entry.value;
                if (entry.name == 'content_type') {
                    if (value == 'redirect') {
                        this.disabled = true;
                    } else {
                        this.disabled = false;
                    }
                }
            },
        },

        image: {
            section: 'image',
            position: 0,
            description: 'Please resize images to 2880px x 800px prior to uploading. The filesize of your image should not exceed <strong>400k</strong>.',
            disabled: function (value, schema, data) {
                return data.template == 'homepage' || data.content_type == 'redirect';
            },
            listener: function (entry, entries, $form) {
                const template = entries.find(entry => entry.name == 'template');
                const content_type = entries.find(entry => entry.name == 'content_type');

                if (template.value == 'homepage' || content_type.value == 'redirect') {
                    this.disabled = true;
                } else {
                    this.disabled = false;
                }
            },
        },

        title: {
            section: 'meta data',
            position: 0,
            listener: function (entry, entries, $form) {
                if (entry.name == 'name' && entry.newValue && !this.value) {
                    this.value = entry.newValue;
                }
            }
        },

        name_id: {
            label: 'Page URL',
            section: 'meta data',
            position: 1,
            description: 'This field will be populated based on page name if left blank',
            prefix: function (value, schema, data) {
                let path = _.get(data, 'path', '');
                path = path.split('/').slice(0, -1).join('/');
                return path ? `/${path}/` : '/';
            },
            listener: function (entry, entries, $form) {
                if (entry.name == 'name' && entry.newValue && !this.value) {
                    this.value = V.slugify(entry.newValue);
                }
                if (entry.name == 'parent_id' && entry.newValue) {
                    let path = _.get(entry.newValue, 'path', '');
                    path = path.split('/').slice(0, -1).join('/');
                    this.prefix = path ? `/${path}/` : '/';
                }
            }
        },

        meta_description: {
            section: 'meta data',
            position: 2,
            component: ExpandableTextComponent,
        },

        meta_keywords: {
            section: 'meta data',
            position: 3,
            component: ExpandableTextComponent,
        },

        meta_no_index: {
            section: 'meta data',
            position: 4,
            description: 'Set this to \"on\" if you do not want this page indexed by search engines',
            cssClass: 'col-sm-6',
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/form.page.js